import React from 'react';
import NavbarStandard from './NavbarStandard';
import Hero from './Hero';
import About from './About';
import TopiczStory from './TopiczStory';
import FitSection from './FitSection';
import Services from './Services';
import OpenClawSection from './OpenClawSection';
import CaseStudies from './CaseStudies';
import Principals from './Principals';
import Cta from './Cta';
import FooterStandard from './FooterStandard';
import 'assets/css/landing-overhaul.css';

const Landing = () => {
  return (
    <div className="wn-landing">
      <NavbarStandard />
      <Hero />
      <About />
      <TopiczStory />
      <FitSection />
      <Services />
      <OpenClawSection />
      <CaseStudies />
      <Principals />
      <Cta />
      <FooterStandard />
    </div>
  );
};

export default Landing;
